var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition-group",
    { attrs: { name: "list", appear: "" } },
    _vm._l(_vm.displayCards, function(card) {
      return _c("div", { key: card.id }, [
        _c("div", [
          _c("a", { attrs: { href: card.link, target: "_blank" } }, [
            _c("div", { staticClass: "card" }, [
              _c("h5", [
                _vm._v(_vm._s(card.contract)),
                _c("span", { staticClass: "timestamp" }, [
                  _vm._v(_vm._s(_vm.formatTimestamp(card.closed, _vm.period)))
                ])
              ]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(card.name))]),
              _vm._v(" "),
              _c("div", { staticClass: "members" }, [
                _vm._v(_vm._s(_vm.members(card)))
              ]),
              _vm._v(" "),
              _vm.settings.cards.labels && card.labels
                ? _c(
                    "div",
                    { staticClass: "card-labels" },
                    _vm._l(card.labels, function(label) {
                      return _c("div", { key: label }, [
                        _c(
                          "div",
                          {
                            staticClass: "card-label",
                            style: { "background-color": _vm.labelColor(label) }
                          },
                          [_vm._v(_vm._s(label))]
                        )
                      ])
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.settings.global.dots
                ? _c(
                    "div",
                    { staticClass: "planned-days" },
                    _vm._l(
                      _vm.dots(_vm.defaultZero(card.planned_days)),
                      function(n, i) {
                        return _c("div", { key: i }, [
                          _c("div", { domProps: { innerHTML: _vm._s(n) } })
                        ])
                      }
                    ),
                    0
                  )
                : _c("div", { staticClass: "planned-days" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.defaultZero(card.planned_days)) +
                        "\n          "
                    )
                  ]),
              _vm._v(" "),
              _vm.settings.global.dots
                ? _c(
                    "div",
                    { staticClass: "progress-days" },
                    _vm._l(
                      _vm.dots(_vm.defaultZero(card.progress_days)),
                      function(n, i) {
                        return _c("div", { key: i }, [
                          _c("div", { domProps: { innerHTML: _vm._s(n) } })
                        ])
                      }
                    ),
                    0
                  )
                : _c("div", { staticClass: "progress-days" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.defaultZero(card.progress_days)) +
                        "\n          "
                    )
                  ])
            ])
          ])
        ])
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0fc87606", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fc87606","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cards/WorkCards.vue
// module id = null
// module chunks = 